/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { WithLazy } from "@quintype/components";
import { PropTypes } from "prop-types";
import React from "react";
import { replaceScriptNodes } from "../../utils";
import { ErrorBoundary } from "../error-boundary";
import "./widget.module.css";

export class CustomWidget extends React.Component {
  constructor(props) {
    super(props);
    this.widgetSlot = React.createRef();
  }
  componentDidMount = () => {
    const currentNode = this.widgetSlot.current;
    currentNode && replaceScriptNodes(currentNode);
  };
  render() {
    if (!this.props.widgetValue) return null;
    return (
      <ErrorBoundary>
        <div
          styleName="widgetWrapper"
          ref={this.widgetSlot}
          dangerouslySetInnerHTML={{ __html: this.props.widgetValue }}
          data-test-id="widget"
        />
      </ErrorBoundary>
    );
  }
}

CustomWidget.propTypes = {
  widgetValue: PropTypes.string
};

export const WidgetComponent = props => {
  return <WithLazy margin="0px">{() => <CustomWidget {...props} />}</WithLazy>;
};

WidgetComponent.propTypes = {
  widgetValue: PropTypes.string
};
